import type { CellContext } from "@tanstack/react-table";
import type { AdminOrderListItem } from "@models/order";
import { formatOrderNumber } from "@utils/formatter";
import { useOrderSelection } from "./orderSelectionContext";

const CHECKBOX_CLASSES = "checkbox checkbox-primary checkbox-sm rounded-full";

// The Orders list's select column (#473): "All" for the rows on this page.
export const SelectAllHeader = () => {
    const {
        allSelected,
        partlySelected,
        isEmpty,
        isRunning,
        isListLoading,
        toggleAll,
    } = useOrderSelection();

    return (
        <label className="flex items-center gap-2 font-normal">
            All
            <input
                ref={(element) => {
                    // A DOM property only: there is no attribute to render.
                    if (element) {
                        element.indeterminate = partlySelected;
                    }
                }}
                type="checkbox"
                className={CHECKBOX_CLASSES}
                aria-label="Select all orders on this page"
                checked={allSelected}
                disabled={isRunning || isListLoading || isEmpty}
                onChange={toggleAll}
            />
        </label>
    );
};

// One row's box.
export const SelectRowCell = ({
    row,
}: CellContext<AdminOrderListItem, unknown>) => {
    const { selectedIds, isRunning, toggleRow } = useOrderSelection();
    const order = row.original;

    return (
        <input
            type="checkbox"
            className={CHECKBOX_CLASSES}
            aria-label={`Select order ${
                order.orderNumberFormatted ??
                formatOrderNumber(order.orderNumber)
            }`}
            checked={selectedIds.has(order.id)}
            disabled={isRunning}
            onChange={() => toggleRow(order.id)}
        />
    );
};
